import React, {Fragment, useState, useEffect} from "react";
import Breadcrumb from "../common/breadcrumb/breadcrumb";
import Dropzone from "react-dropzone-uploader";
import config from '../../app/config';

import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Modal, ModalBody, ModalFooter, ModalHeader,
  Input,
  Button,
} from "reactstrap";
import sessionUtils from "./sessionsutils";
import DatePicker from "react-datepicker";
import {useForm} from "react-hook-form";
import {ToastContainer, toast} from "react-toastify";
import moment from 'moment';
import { useAppNavigate } from "../../utils/link.utils";
import {gruppi} from "../../api/groups";
import {recorder} from "../../api/recorder";
import {sessionManageUtils} from "../../component/common/session/manage/sessionManage.utils";
import {downloadFile} from "../../utils/download.utils";
import {useQuery} from '../../hook/useQuery'
import {IconTooltip} from "../common/iconTooltip/IconTooltip";

const AddSession = (props) => {
  const query = useQuery();
  // const tags = [{name: "Comune di Roma"}, {name: "Giunta Comunale"}, {name: "Video del giorno"}];
  const [data, setData] = useState(query.get('date') ? new Date(new Number(query.get('date'))) : new Date());
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(prev => !prev);
  const navigate = useAppNavigate();
  const [last10sessions, setLast10Sessions] = useState([]);
  const [id, setId] = useState();
  const [descrizione, setDescrizione] = useState('');
  const [nome, setNome] = useState('');
  const [gruppo, setGruppo] = useState('');
  const [groupList, setGroupList] = useState([]);
  const [gruppoRelatori, setGruppoRelatori] = useState('');
  const [speakerGroupList, setSpeakerGroupList] = useState([]);
  const [file, setFile] = useState({});
  const [isloading, setIsLoading] = useState(false);
  const [linkTrascrizione, setLinkTrascrizione] = useState('')
  const [linkVideo, setLinkVideo] = useState('')
  const [linkPdf, setLinkPdf] = useState('')
  const [content, setContent] = useState('')
  const [trascrizioni, setTrascrizioni] = useState()
  const [numsessione, setNumSessione] = useState('');
  const [timenote, setTimenote] = useState('');
  const [loadedSession, setLoadedSession] = useState();
  const [transcriptionExtensionAllowed, setTranscriptionExtensionAllowed] = useState(".pvt, .pvml" );
  const columns = [
    {
      name: "Tipo",
      selector: "tipo",
      sortable: true,
      center: true,
      width: '10%',
      default: 'Video',
      format: (row) => {
        return (
          <img
            className="img-100 img-fluid m-r-20"
            src='/images/video_icon_sm.png'
            alt=""
          />
        )
      },
    },
    {
      name: "Nome",
      selector: "name",
      sortable: true,
      center: true,
      className: "default-text mb-0 f-w-700 f-18",
      style: 'color: var(--primary-color);font-weight: 700;font-size: 14px;',
      width: '25%'

    },

    // {
    //   name: "Gruppo",
    //   selector: "gruppo",
    //   sortable: true,
    //   center: true,
    //   format : (row) => {
    //     return (<span class="badge badge-pill recent-badge f-12">{row.gruppo}</span>)
    //   },
    //   width:'15%'
    // },

    {
      name: "Data evento",
      selector: "timestamp",
      sortable: true,
      center: true,
      width: '20%',
      format: (row) => {
        return moment(new Date(row.timestamp)).format('DD/MM/YYYY h:mm:ss')

      }
    },


    {
      name: "Azioni",
      selector: "id",
      sortable: true,
      center: true,
      format: (row) => {
        return (
          <>
            <IconTooltip
              icon={'icon-eye'}
              id={row.id}
              link={`/sessions/view?id=${row.id}`}
              tooltipMessage={'Guarda'}
              className={'btn-primary'}
            />
            &nbsp;
            <IconTooltip
              icon={'icofont icofont-video-clapper'}
              id={row.id}
              link={`/sessions/manage?id=${row.id}`}
              tooltipMessage={'Gestisci'}
              className={'btn-warning'}
            />
            &nbsp;
            <span onClick={() => onEditClick(row)}><IconTooltip
              icon={'icon-pencil'}
              id={row.id}
              tooltipMessage={'Modifica'}
              className={'btn-secondary'}
            /></span>
          </>
        )
      },
    },
  ];

  const getUploadParams = ({file}) => {
    const formData = new FormData();
    formData.append('file', file);
    return {
      // use this to skip origin
      //url: `/api/recorder/v1/upload`,
      url: `${config.serverUrl}/api/recorder/v1/upload`,
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('session_token')}`
      },
      body: formData
    };
  };


  useEffect(() => {
    init()

  }, []);

  async function init() {

    try {
      await loadSessions();
      const groups = await gruppi.methods.loadGruppi()
 
      setGroupList(groups);

      if (groups && groups.length == 1) {
        document.getElementById('input_gruppo').value = groups[0].id;
        setGruppo(groups[0].id);
      }

      // const speakerGroups = await gruppi_relatori.methods.loadGruppiRelatori()
      const speakerGroups = [];
      setSpeakerGroupList(speakerGroups);

      if (speakerGroups && speakerGroups.length == 1) {
        document.getElementById('input_gruppo').value = speakerGroups[0].id;
        setGruppoRelatori(speakerGroups[0].id);
      }

      if (query.get('id')) {
        setId(query.get('id'));
        console.log(query.get('id'));
        try {
          const sessionemodify = await sessionUtils.methods.loadSessioni(query.get('id'));
          console.log(sessionemodify);
          if (sessionemodify) {
            setLoadedSession(sessionemodify);
            loadFormEdit(sessionemodify);
          }

        } catch (e2) {
          console.error(e2);
        }


      }

    } catch (e) {
      console.log(e)
    }
  }

  const loadSessions = async (refresh) => {
      //session.methods.saveSession()
      console.log('loadPage')
      const listasessioniraw = await sessionUtils.methods.loadSessioni();
      let listasessioni = listasessioniraw.sort(function (a, b) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(b.timestamp) - new Date(a.timestamp);
      })
      if (listasessioni && listasessioni.length > 0 && (listasessioni['id'] || Array.isArray(listasessioni))) {
        setLast10Sessions(listasessioni.slice(listasessioni.length - 30));
      } else {
        setLast10Sessions([]);
      } 

  }

  const clearForm = () => {
    setId(null);
    setGruppo('');
    setDescrizione('');
    setNome('');
    setGruppoRelatori('');
    setFile(null);
    setData(new Date());
    setLinkTrascrizione('')
    setLinkVideo('')
    setLinkPdf('')
    setNumSessione('')
    setContent('');
    setTrascrizioni(null);
    document.getElementById('input_gruppo').value = '';
    // document.getElementById('input_gruppo_relatori').value = '';
  }

  async function onEditClick(row) {
    clearForm();
    loadFormEdit(row);

  }

  const destroy = async (id) => {
    try {
      console.log('destroy session: ' + id);

      const searchItem = await loadElasticSearchSession(id);
      // ElasticSearch 
      const destroyElasticSession = await sessionUtils.methods.destroyElasticSession({
        groupId: searchItem.groupId,
        ownerId: localStorage.getItem('id'),
        itemId:  searchItem.id,
      });
      if (!destroyElasticSession) {
        toast.error("Qualcosa è andato storto...");
      }

      const destroySession = await sessionUtils.methods.destroySession(id);
      if (!destroySession) {
        toast.error("Qualcosa è andato storto...");
      }

    } catch (e) {
      console.error(e)
      toast.error("Qualcosa è andato storto...");
    } finally {
      setModal(false);
      navigate('/sessions')
    }
    
  }

  function onResetClick(){
    clearForm();
    if (query.get('id')) {
      loadFormEdit(loadedSession);
    }
  }
  const loadFormEdit = (row) => {
    console.log("Loading form edit ["+row+"]");
    setNumSessione('')
    setId(row.id);
    setGruppo(row.idGroup);
    setSpeakerGroupSubsetList(row.idGroup);
    setGruppoRelatori(row.idSpeakerGroup);
    setDescrizione(row.description);
    setNome(row.name);
    setFile({});
    if(row.timenote){
      setTimenote(row.timenote);
    }
    if (row.trascrizioni)
      setLinkTrascrizione(row.trascrizioni.revisionFile ? row.trascrizioni.revisionFile : row.trascrizioni.originalFile);
    setTrascrizioni(row.trascrizioni);
    setLinkVideo(row.linkVideo);
    setLinkPdf(row.linkPdf);

    setData(new Date(row.timestamp))
    if (row.numeroSessione != null)
      setNumSessione(row.numeroSessione)
    document.getElementById('input_gruppo').value = row.idGroup;
    // document.getElementById('input_gruppo_relatori').value = row.idSpeakerGroup;
    setId(row.id);
    console.log("setTranscriptionExtensionAllowed -> txt");
    setTranscriptionExtensionAllowed(".pvt, .pvml, .docx, .txt");
  }

  const submit = async () => {
    setIsLoading(true);

    const inputobject = {
      "nome": nome,
      "data": data,
      "gruppo": gruppo,
      "gruppo_relatori": gruppoRelatori,
      "descrizione": descrizione,
      "numeroSessione": numsessione
    }
    if(timenote){
      inputobject.timenote = timenote;
    }

    var isToConvert = false;
    if (file?.videoUrl || linkVideo)
      inputobject.linkVideo = (file?.videoUrl) ? file?.videoUrl : linkVideo;
    if (file?.pdfUrl || linkPdf)
      inputobject.linkPdf = (file?.pdfUrl) ? file?.pdfUrl : linkPdf;   
    if (file?.trascrizioneUrl || linkTrascrizione) {

      // const fileType = linkTrascrizione.indexOf('.pvt') > -1 ? "pvt" : 'pvml';
      const fileType = linkTrascrizione.split('.').pop();
      const paramName = fileType;
      if (file?.trascrizioneUrl) {
        isToConvert = true;
      }
      if (!trascrizioni) {
        inputobject.trascrizioni = JSON.parse(`{
            "${paramName}" : "${(file?.trascrizioneUrl) ? file?.trascrizioneUrl : linkTrascrizione}",
            "originalFile" : "${(file?.trascrizioneUrl) ? file?.trascrizioneUrl : linkTrascrizione}" 
            }`);
      } else {
        inputobject.trascrizioni = trascrizioni;
        if (trascrizioni.originalFile != '') {
          inputobject.trascrizioni.revisionFile = (file?.trascrizioneUrl) ? file?.trascrizioneUrl : linkTrascrizione;
        }
      }
    }

    // todo ?
    if (content && content != '') {
      inputobject.content = content;
    }

    if (id) inputobject.id = id;
    const validateresult = sessionUtils.methods.validateSession(inputobject, file);
    if (validateresult.length > 0) {
      //TODO gestire validate field su campo input
      validateresult.forEach((e) => {
          console.log(e);
          toast.error(
            e.field + ':' + e.error
          );

        }
      );
      setIsLoading(false)

      return;
    }
    try {
      console.debug("Saving session");
      console.debug(inputobject);
      const savedSession = await sessionUtils.methods.saveSession(inputobject);
	  setId(savedSession.id);
      console.debug("Saved session");
      console.debug(savedSession);
      // console.debug("content");
      // console.debug(content);
      if (content && content != '') {
        savedSession.content = content;
      }
      if (file?.trascrizioneUrl || linkTrascrizione) {
        savedSession.linkTrascrizione = (file?.trascrizioneUrl) ? file?.trascrizioneUrl : linkTrascrizione;
      }
      if (!id) {
        console.debug("Adding in archive");
        console.debug(savedSession);
        try {
          await recorder.methods.addInArchive(sessionUtils.parser.sessionToRecorderSession(savedSession));
        }catch(err){
          await sessionUtils.methods.destroySession(savedSession.id);
          setId(null);
          throw err;
        }
      } else {
        console.log(id);
        const searchItem = await loadElasticSearchSession(id);
        searchItem.itemId = String(searchItem.id);
        delete searchItem.id;
        await recorder.methods.editInArchive(modifyVideoItem(searchItem, inputobject));
      }


      if (isToConvert) {
        await recorder.methods.convertTranscription({idSessione: savedSession.id})
      }

      if (file?.videoUrl){
        await recorder.methods.convertMultimediaToMp3({idSessione: savedSession.id})
      }

      console.log("Session saved: ", savedSession);

      toast.success("Sessione salvata...");
      navigate(`/sessions/manage?id=${savedSession.id}`)
    } catch (e) {
      console.error(e)
      toast.error("Qualcosa è andato storto...");
    } finally {
      setIsLoading(false);
    }

  }

  function modifyVideoItem(readsession, formsession) {

	readsession.name = formsession.nome;
	readsession.description = formsession.descrizione;
	
	readsession.referenceDate = moment(formsession.data.getTime()).format('DD/MM/YYYY');
	readsession.date = readsession.referenceDate;

	let typeTagsNumeroSessione = readsession.typeTags.find(tt => tt.type === 'NUMEROSESSIONE');	
	typeTagsNumeroSessione.tags = [formsession.numeroSessione];

    if (formsession.trascrizioni) {
      if (readsession.transcriptionURL != (formsession.trascrizioni.revisionFile ? formsession.trascrizioni.revisionFile : (formsession.trascrizioni.originalFile ? formsession.trascrizioni.originalFile : readsession.transcriptionURL))) {
        readsession.transcriptionURL = (formsession.trascrizioni.revisionFile ? formsession.trascrizioni.revisionFile : (formsession.trascrizioni.originalFile ? formsession.trascrizioni.originalFile : readsession.transcriptionURL));
      }
    }
    if ((readsession.content != formsession.content) || formsession.content) {
      readsession.content = formsession.content;
    }
	//console.debug("modifyVideoItem successfully");
	//console.debug(readsession);
    return readsession;
  }

  async function setSpeakerGroupSubsetList(idGroup) {
    console.log('setSpeakerGroupSubsetList');
    if (idGroup) { 
      // const speakerGroups = await gruppi_relatori.methods.loadGruppiRelatoriPerGruppo(idGroup)
      // setSpeakerGroupList(speakerGroups);
      setSpeakerGroupList([]);
    } else {
      setSpeakerGroupList([]);
    }

  }

  async function loadElasticSearchSession(sessionId) {
    try {
      const search = await sessionUtils.methods.queryElasticSearch(sessionManageUtils.searchSessionParams({
        groupId: localStorage.getItem('grp'),
        ownerId: localStorage.getItem('id'),
        roleType: localStorage.getItem('rl').toUpperCase(),
        sessionId,
        toString: true
      }));
      const searchResponse = search.payload[0].videoItem;
      console.log('SEARCH: ', searchResponse);
      return searchResponse;
      //setElasticSearch(searchResponse);
    } catch (e) {
      toast.error('Qualcosa è andato storto');
    }
  }

  // called every time a file's `status` changes
  const handleVideoChangeStatus = ({meta, file, xhr}, status) => {
    console.log(meta);
    console.log(file);
    console.log(status);
    setIsLoading(true)

    if (status === 'done') {
      console.log(xhr.response);
      let response = JSON.parse(xhr.response);
      setFile(file => ({...file, videoUrl: response.key}))
      setIsLoading(false)
      console.log(response);
    }
  };

  const handlePdfChangeStatus = ({meta, file, xhr}, status) => {
    console.log('handlePdfChangeStatus');
    setIsLoading(true)

    if (status === 'done') {
      console.log(xhr.response);
      let response = JSON.parse(xhr.response);
      setFile(file => ({...file, pdfUrl: response.key}))
      setIsLoading(false)
      console.log(response);
    }
  };

  const handleTrascrizioneChangeStatus = ({meta, file, remove, xhr}, status) => {
	console.log("handleTrascrizioneChangeStatus");
	console.log("status -> " + status);
   
    if (status === 'done') {
      console.log(xhr.response);
      let response = JSON.parse(xhr.response);
      setFile(file => ({...file, trascrizioneUrl: response.key}))
      setContent(response.text);
      console.log(content);
      setLinkTrascrizione(response.key);
      setIsLoading(false)
      console.log(response);
    }else if(status === 'error_upload' && xhr.readyState == 2){
	  toast.error("Qualcosa è andato storto...");
	  remove();
	}
  };

  const {register, handleSubmit, errors} = useForm(); // initialise the hook

  return (
    <Fragment>
      <Breadcrumb parent="Sessioni" title="Gestisci" subtitle="Sessioni"/>
      <Container fluid={true}>
        <Row>
          <Col xs="12" sm="4" md="4" xl="4">
            <Card className="card-absolute">
              <CardHeader className="bg-primary">
                <h5>Upload</h5>
              </CardHeader>
              <CardBody className="add-post">
                <div className="media static-top-widget">
                  <div className="media-body">

                    <Row>
                      <Col xs="12" sm="12">
                        <Form id="savefiles" className="dropzone digits">
                          <div className="m-0 dz-message needsclick">

                            <Label>Video/Audio</Label>
                            <Dropzone
                              key='file_video'
                              getUploadParams={getUploadParams}
                              onChangeStatus={handleVideoChangeStatus}
                              maxFiles={1}
                              multiple={false}
                              canCancel={false}
                              accept='.mp3, .mp4, .wav'
                              inputContent="Trascina i files qui o premi per sceglierli"
                              styles={{
                                dropzone: {width: "100%", height: 50},
                                dropzoneActive: {borderColor: "green"},
                              }}
                            />
                          </div>
                          <div style={{width: '90%', margin: 'auto', textAlign: 'center'}}>
                            {
                              (linkVideo != '') ? (
                                <Button color="secondary btn-pill" type="reset" onClick={() => downloadFile(linkVideo, nome)}>
                                  Scarica Video
                                </Button>) : ''
                            }
                          </div>
                        </Form>
                      </Col>
                      <Col xs="12" sm="12">
                        <Form className="dropzone digits">
                          <div className="m-0 dz-message needsclick">
                            <Label>Trascrizione</Label>
                            <Dropzone
                              key='file_trascrizione'
                              getUploadParams={getUploadParams}
                              onChangeStatus={handleTrascrizioneChangeStatus}
                              maxFiles={1}
                              multiple={false}
                              canCancel={false}
                              inputContent="Trascina i files qui o premi per sceglierli"
                              styles={{
                                dropzone: {width: "100%", height: 50},
                                dropzoneActive: {borderColor: "green"},
                              }}
                              accept={transcriptionExtensionAllowed}
                            />
                          </div>
                          <div style={{width: '90%', margin: 'auto', textAlign: 'center'}}>
                            {
                              (linkTrascrizione != '') ? (
                                <Button color="secondary btn-pill" type="reset"
                                        onClick={() => downloadFile(linkTrascrizione, nome)}>
                                  Scarica Tracciato
                                </Button>) : ''
                            }
                          </div>

                        </Form>
                      </Col>

                      <Col xs="12" sm="12">
                        <Form id="savefiles" className="dropzone digits">
                          <div className="m-0 dz-message needsclick">

                            <Label>PDF</Label>
                            <Dropzone
                              key='file_pdf'
                              getUploadParams={getUploadParams}
                              onChangeStatus={handlePdfChangeStatus}
                              maxFiles={1}
                              multiple={false}
                              canCancel={false}
                              accept='.pdf'
                              inputContent="Trascina i files qui o premi per sceglierli"
                              styles={{
                                dropzone: {width: "100%", height: 50},
                                dropzoneActive: {borderColor: "green"},
                              }}
                            />
                          </div>
                          <div style={{width: '90%', margin: 'auto', textAlign: 'center'}}>
                            {
                              (linkPdf && linkPdf != '') ? (
                                <Button color="secondary btn-pill" type="reset" onClick={() => downloadFile(linkPdf, nome)}>
                                  Scarica PDF
                                </Button>) : ''
                            }
                          </div>
                        </Form>
                      </Col>
                    </Row>


                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xs="12" sm="8" md="8" xl="8">
            <Card className="card-absolute">
              <CardHeader className="bg-primary">
                <h5>Dati Sessione</h5>
              </CardHeader>
              <CardBody className="add-post">
                <Form id="savesession" className="row needs-validation">
                  <Col sm="12">
                    <Row>
                      <Col xs="12" sm="6" md="6" xl="6" lg="6">
                        <FormGroup>
                          <Label for="validationCustom01">Nome:</Label>
                          <Input
                            className="form-control"
                            id="input_nome_sessione"
                            type="text"
                            placeholder="Nome della sessione"
                            required={true}
                            value={nome}
                            onChange={(e) => {
                              setNome(e.target.value)
                            }}
                          />
                          <div className="valid-feedback">Ok!</div>
                        </FormGroup>

                      </Col>
                      <Col xs="12" sm="6" md="6">


                        <FormGroup>
                          <div className="date-picker">
                            <Label for="validationCustom01">Data/Ora:</Label>
                            <DatePicker
                              className="form-control digits"
                              id='input_data_sessione'
                              showPopperArrow={false}
                              selected={data}
                              onChange={(e) => {
                                setData(e)
                              }}
                              showTimeSelect
                              dateFormat="dd/MM/yyyy HH:mm"
                            />
                          </div>
                        </FormGroup>

                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12" sm="6">
                        <Row>
                          <Col xs="12" sm="6">
                            <FormGroup>
                              <Label for="validationCustom01">Numero sessione:</Label>
                              <Input
                                className="form-control"
                                id="input_num_sessione"
                                type="text"
                                placeholder=""
                                required={true}
                                value={numsessione}
                                onChange={(e) => {
                                  setNumSessione(e.target.value)
                                }}
                              />
                              <div className="valid-feedback">Ok!</div>
                            </FormGroup>
                          </Col>

                        </Row>


                      </Col>
                      <Col xs="12" sm="6">

                        <Label for="basic-typeahead-example">Gruppo:</Label>
                        <select id="input_gruppo" className="form-control btn-pill" size="1" onChange={(e) => {
                          setGruppo(e.target.value);
                          setSpeakerGroupSubsetList(e.target.value);
                        }}>
                          <option value=''>Seleziona</option>
                          {groupList.map(g => {
                            return <option value={g.id}>{g.name}</option>
                          })}
                        </select>
                      </Col>
                    </Row>

                    <FormGroup className="mb-0">
                      <Label>Descrizione</Label>
                      <Input
                        type="textarea"
                        className="form-control"
                        rows="3"
                        onChange={(e) => setDescrizione(e.target.value)}
                        value={descrizione}
                      />
                    </FormGroup>
                  </Col>
                </Form>
                <Row>
                  &nbsp;
                </Row>
                <div className="btn-showcase" style={{textAlign: 'right'}}>
                  {id && <Button color="danger btn-pill" type="reset" onClick={()=>setModal(true)}>
                    Elimina
                  </Button>}
                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle}>Elimina sessione</ModalHeader>
                    <ModalBody>Sei sicuro di volere proseguire?</ModalBody>
                    <ModalFooter>
                      <Button color="info" onClick={toggle}>
                        Annulla
                      </Button>
                      <Button color="primary" onClick={()=>destroy(id)}>
                        OK
                      </Button>
                    </ModalFooter>
                  </Modal>


                  <Button disabled={isloading} id="buttonsubmit" color="primary btn-pill" type="button"
                          onClick={submit}>
                    {id ? 'Modifica' : 'Aggiungi'}
                  </Button>
                  <Button color="danger btn-pill" type="reset" onClick={()=>onResetClick()}>
                    Annulla
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>

        </Row>

        <ToastContainer/>
      </Container>
    </Fragment>
  );
};

export default AddSession;
